import { Tooltip } from 'antd';
import { TModule } from 'features/module/type';
import { MenuItem } from 'layouts/MainLayout/AppMainSidebar/constants';

export const renderSidebarLabel = (label: string) => {
  return (
    <Tooltip title={label} placement="right">
      {label}
    </Tooltip>
  );
};

export const filterMenuItemsByPermissions = (
  menuItems: MenuItem[],
  permissions: TModule[]
): MenuItem[] => {
  const permissionMap = new Map<string, TModule>();

  const flattenPermissions = (items: TModule[]) => {
    for (const item of items) {
      permissionMap.set(item.code, item);
      if (item.sub_modules) flattenPermissions(item.sub_modules);
    }
  };

  flattenPermissions(permissions);

  const filterMenuItems = (items: MenuItem[]): MenuItem[] =>
    items
      .map(item => {
        const module = permissionMap.get(item.code);

        if (!module || !module.status) return null;

        const newItem = { ...item };

        if (item.children) {
          newItem.children = filterMenuItems(item.children as MenuItem[]);

          if (!newItem.children.length) return null;
        }

        return newItem;
      })
      .filter(Boolean) as MenuItem[];

  return filterMenuItems(menuItems);
};
